import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import ImageWithBasePath from "../imageWithBasePath";
import "../../../style/icon/tabler-icons/webfont/tabler-icons.css";
import { setExpandMenu } from "../../data/redux/sidebarSlice";
import { useDispatch } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
// import usePreviousRoute from "./usePreviousRoute";
import { SidebarDataTest } from "../../data/json/sidebarMenu";
import logo from "../../../assests/logo/new_logo.png";
import logo1 from "../../../assests/logo/new_logo (1).png";

const Sidebar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  // const previousLocation = usePreviousRoute();
  const [subOpen, setSubopen] = useState<any>(
    () => localStorage.getItem("menuOpened") || "Dashboard",
  );
  const [subsidebar, setSubsidebar] = useState("");

  // Tracks the minimize button state locally (mirrors the "mini-sidebar"
  // body class) so the label can hide reliably without depending on
  // external CSS we don't control here.
  const [isMinimized, setIsMinimized] = useState(
    () =>
      typeof document !== "undefined" &&
      document.body.classList.contains("mini-sidebar"),
  );
  // True while the mouse is over the sidebar — lets a minimized sidebar
  // still temporarily reveal labels on hover, same as most admin templates.
  const [isHoveringSidebar, setIsHoveringSidebar] = useState(false);

  // Labels/arrows/badges are visible whenever the sidebar isn't minimized,
  // or when it is minimized but currently being hovered.
  const showLabels = !isMinimized || isHoveringSidebar;

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const handleLayoutChange = (layout: string) => {
    dispatch(setDataLayout(layout));
  };

  const handleClick = (label: any, themeSetting: any, layout: any) => {
    toggleSidebar(label);
    if (themeSetting) {
      handleLayoutChange(layout);
    }
  };

  const getLayoutClass = (label: any) => {
    switch (label) {
      case "Default":
        return "default_layout";
      case "Mini":
        return "mini_layout";
      case "Box":
        return "boxed_layout";
      case "Dark":
        return "dark_data_theme";
      case "RTL":
        return "rtl";
      default:
        return "";
    }
  };

  useEffect(() => {
    const currentMenu = localStorage.getItem("menuOpened") || "";
    if (currentMenu) {
      setSubopen(currentMenu);
      const submenus = document.querySelectorAll(".submenu");
      submenus.forEach((submenu) => {
        const listItems = submenu.querySelectorAll("li");
        submenu.classList.remove("active");
        listItems.forEach((item) => {
          if (item.classList.contains("active")) {
            submenu.classList.add("active");
            return;
          }
        });
      });
    }
  }, [location.pathname]);

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
    setIsHoveringSidebar(true);
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
    setIsHoveringSidebar(false);
  };

  const [hover, sethover] = useState("");

  // Minimize/collapse toggle — flips the template's existing
  // "mini-sidebar" body class and keeps local state in sync so the
  // label rendering below reacts immediately.
  const toggleMiniSidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    setIsMinimized(document.body.classList.contains("mini-sidebar"));
  };

  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ fontFamily: "'Roboto', sans-serif" }}
      >
        <div className="sidebar-logo">
          <Link to="/getBatches/lesson_plan" className="logo logo-normal">
            <img src={logo} alt="Logo" />
          </Link>
          <Link to="/getBatches/lesson_plan" className="logo-small">
            <img src={logo1} alt="Logo" />
          </Link>
          <Link to="/getBatches/lesson_plan" className="dark-logo">
            <ImageWithBasePath src="assets/img/logo-white.svg" alt="Logo" />
          </Link>
          {/* <button
            type="button"
            className="btn btn-menubar sidebar-minimize-btn"
            onClick={toggleMiniSidebar}
            aria-label="Minimize sidebar"
            style={{ marginLeft: "auto" }}
          >
            <i className="ti ti-layout-sidebar-left-collapse"></i>
          </button> */}
        </div>
        <div className="modern-profile p-3 pb-0">
          <div className="text-center rounded bg-light p-3 mb-4 user-profile">
            {/* <div className="avatar avatar-lg online mb-3">
              <ImageWithBasePath
                src="assets/img/profiles/avatar-02.jpg"
                alt="Img"
                className="img-fluid rounded-circle"
              />
            </div> */}
            <h6 className="fs-12 fw-normal mb-1">Adrian Herman</h6>
            <p className="fs-10">System Admin</p>
          </div>
          <div className="sidebar-nav mb-3">
            <ul
              className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
              role="tablist"
            >
              <li className="nav-item">
                <Link className="nav-link active border-0" to="#">
                  Menu
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link border-0" to="#">
                  Chats
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link border-0" to="#">
                  Inbox
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="sidebar-header p-3 pb-0 pt-2">
          <div className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
            <div className="avatar avatar-md onlin">
              <ImageWithBasePath
                src="assets/img/profiles/avatar-02.jpg"
                alt="Img"
                className="img-fluid rounded-circle"
              />
            </div>
            <div className="text-start sidebar-profile-info ms-2">
              <h6 className="fs-12 fw-normal mb-1">Adrian Herman</h6>
              <p className="fs-10">System Admin</p>
            </div>
          </div>
          <div className="input-group input-group-flat d-inline-flex mb-4">
            <span className="input-icon-addon">
              <i className="ti ti-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search in HRMS"
            />
            <span className="input-group-text">
              <kbd>CTRL + / </kbd>
            </span>
          </div>
          <div className="d-flex align-items-center justify-content-between menu-item mb-3">
            <div className="me-3">
              <Link to="#" className="btn btn-menubar position-relative">
                <i className="ti ti-shopping-bag"></i>
                <span className="badge bg-success rounded-pill d-flex align-items-center justify-content-center header-badge">
                  5
                </span>
              </Link>
            </div>
            <div className="me-3">
              <Link to="#" className="btn btn-menubar">
                <i className="ti ti-layout-grid-remove"></i>
              </Link>
            </div>
            <div className="me-3">
              <Link to="#" className="btn btn-menubar position-relative">
                <i className="ti ti-brand-hipchat"></i>
                <span className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">
                  5
                </span>
              </Link>
            </div>
            <div className="me-3 notification-item">
              <Link to="#" className="btn btn-menubar position-relative me-1">
                <i className="ti ti-bell"></i>
                <span className="notification-status-dot"></span>
              </Link>
            </div>
            <div className="me-0">
              <Link to="#" className="btn btn-menubar">
                <i className="ti ti-message"></i>
              </Link>
            </div>
          </div>
        </div>
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {SidebarDataTest?.map((mainLabel, index) => (
                  <React.Fragment key={`main-${index}`}>
                    {/* <li className="menu-title">
                        <span>{mainLabel?.tittle}</span>
                      </li> */}
                    <li>
                      <ul>
                        {mainLabel?.submenuItems?.map((title: any, i) => {
                          let link_array: any = [];
                          if ("submenuItems" in title) {
                            title.submenuItems?.forEach((link: any) => {
                              link_array.push(link?.link);
                              if (link?.submenu && "submenuItems" in link) {
                                link.submenuItems?.forEach((item: any) => {
                                  link_array.push(item?.link);
                                });
                              }
                            });
                          }
                          title.links = link_array;

                          const isActiveColor =
                            subOpen === title?.label || hover === title?.label
                              ? "#fff"
                              : "#000";

                          return (
                            <li className="submenu" key={`title-${i}`}>
                              <Link
                                to={title?.submenu ? "#" : title?.link}
                                onClick={() =>
                                  handleClick(
                                    title?.label,
                                    title?.themeSetting,
                                    getLayoutClass(title?.label),
                                  )
                                }
                                onMouseEnter={() => sethover(title?.label)}
                                onMouseOut={() => sethover("")}
                                className={`${
                                  subOpen === title?.label ? "subdrop" : ""
                                } ${
                                  title?.links?.includes(location.pathname)
                                    ? "active"
                                    : ""
                                } ${
                                  title?.submenuItems
                                    ?.map((link: any) => link?.link)
                                    .includes(location.pathname) ||
                                  title?.link === location.pathname
                                    ? "active"
                                    : ""
                                }`}
                                style={{
                                  padding: "5px 0px 5px 10px",
                                  display: "flex",
                                  alignItems: "center",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {/* Fixed-width icon slot — stays put whether
                                      the sidebar is minimized or expanded. */}
                                <span
                                  style={{
                                    width: "20px",
                                    minWidth: "20px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  <i
                                    className={`ti ti-${title.icon}`}
                                    style={{ color: isActiveColor }}
                                  ></i>
                                </span>

                                {/* Label clips to 0 width and fades out when
                                      minimized instead of wrapping/overlapping
                                      the icon. */}
                                <span
                                  className="sidebar-label"
                                  style={{
                                    color: isActiveColor,
                                    marginLeft: showLabels ? "10px" : "0px",
                                    fontSize: "13px",
                                    fontFamily: "system-ui",
                                    fontWeight: 600,
                                    display: "inline-block",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    maxWidth: showLabels ? "170px" : "0px",
                                    opacity: showLabels ? 1 : 0,
                                    transition:
                                      "max-width 0.2s ease, opacity 0.15s ease, margin-left 0.2s ease",
                                  }}
                                >
                                  {title?.label}
                                </span>

                                {title?.dot && showLabels && (
                                  <span className="badge badge-danger fs-10 fw-medium text-white p-1 ms-1">
                                    Hot
                                  </span>
                                )}
                                {showLabels && (
                                  <span
                                    className={
                                      title?.submenu ? "menu-arrow" : ""
                                    }
                                  />
                                )}
                              </Link>
                              {title?.submenu !== false &&
                                subOpen === title?.label && (
                                  <ul
                                    style={{
                                      display:
                                        subOpen === title?.label
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    {title?.submenuItems?.map(
                                      (item: any, j: any) => (
                                        <li
                                          className={
                                            item?.submenuItems
                                              ? "submenu submenu-two"
                                              : ""
                                          }
                                          key={`item-${j}`}
                                        >
                                          <Link
                                            to={
                                              item?.submenu ? "#" : item?.link
                                            }
                                            className={`${
                                              item?.submenuItems
                                                ?.map((link: any) => link?.link)
                                                .includes(location.pathname) ||
                                              item?.link === location.pathname
                                                ? "active"
                                                : ""
                                            } ${
                                              subsidebar === item?.label
                                                ? "subdrop"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              toggleSubsidebar(item?.label);
                                            }}
                                          >
                                            {item?.label}
                                            <span
                                              className={
                                                item?.submenu
                                                  ? "menu-arrow"
                                                  : ""
                                              }
                                            />
                                          </Link>
                                          {item?.submenuItems ? (
                                            <ul
                                              style={{
                                                display:
                                                  subsidebar === item?.label
                                                    ? "block"
                                                    : "none",
                                              }}
                                            >
                                              {item?.submenuItems?.map(
                                                (items: any, k: any) => (
                                                  <li key={`submenu-item-${k}`}>
                                                    <Link
                                                      to={
                                                        items?.submenu
                                                          ? "#"
                                                          : items?.link
                                                      }
                                                      className={`${
                                                        subsidebar ===
                                                        items?.label
                                                          ? "submenu-two subdrop"
                                                          : "submenu-two"
                                                      } ${
                                                        items?.submenuItems
                                                          ?.map(
                                                            (link: any) =>
                                                              link.link,
                                                          )
                                                          .includes(
                                                            location.pathname,
                                                          ) ||
                                                        items?.link ===
                                                          location.pathname
                                                          ? "active"
                                                          : ""
                                                      }`}
                                                    >
                                                      {items?.label}
                                                    </Link>
                                                  </li>
                                                ),
                                              )}
                                            </ul>
                                          ) : null}
                                        </li>
                                      ),
                                    )}
                                  </ul>
                                )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  </React.Fragment>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
